import type { RequestParams } from '@/shared/api';
import type { CourierItemListParams } from '../model/types';

export const COURIER_KEYS = {
  all: ['courier'] as const,
  list: (params?: RequestParams) => [...COURIER_KEYS.all, 'list', params] as const,
  detail: (id: number) => [...COURIER_KEYS.all, 'detail', id] as const,
  itemList: (params?: CourierItemListParams) => [...COURIER_KEYS.all, 'item-list', params] as const,
};
